import { utils, LitElement, html, broadcastReceiver } from '@hh/global.js'

const { serializeForm, addToCart, reRenderShopifySections } = utils

class HHProductForm extends LitElement {
  static properties = {
    showMiniCartAfterSubmission: {
      type: Boolean,
      attribute: 'show-mini-cart',
    },
  }

  constructor() {
    super()

    this.mainProduct = this.closest(`#ProductInfo-${this.dataset.section}`)
    this.form = this.querySelector('form')
    this.quanityInput = this.querySelector('[name="quantity"]')
    this.submitButton = this.querySelector('[type="submit"]')

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
  }

  connectedCallback() {
    super.connectedCallback()

    this.receiver = broadcastReceiver('quantity', (...args) => {
      this.getQuantityFromDocument(...args)
    })

    setTimeout(() => {
      this.setSpacerHeight()
    }, 100)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.receiver?.disconnect()
  }

  getQuantityFromDocument(data) {
    if (this.quanityInput) {
      this.quanityInput.value = data.value || 1
    }
  }

  async onSubmitHandler(event) {
    event.preventDefault()

    const formData = JSON.parse(serializeForm(this.form))
    let engraving_class = '.engraving-input--text'
    if (
      this.mainProduct.querySelector(engraving_class) &&
      this.mainProduct.querySelector(engraving_class).value.trim() === ''
    ) {
      this.mainProduct.querySelector('.js-error-engraving-required').classList.remove('hidden')
      setTimeout(() => {
        this.mainProduct.querySelector(engraving_class).focus()
      }, 150)
      return false
    }

    engraving_class = '.engraving-input--text-optional'
    if (
      this.mainProduct.querySelector(engraving_class) &&
      this.mainProduct.querySelector(engraving_class).value.trim() !== ''
    ) {
      if (formData.properties) {
        formData.properties['Personalization'] = this.mainProduct.querySelector(engraving_class).value.trim()
      } else {
        formData.properties = {
          'Personalization': this.mainProduct.querySelector(engraving_class).value.trim()
        }
      }
    }

    this.submitButton.setAttribute('disabled', true)
    this.submitButton.classList.add('loading')

    reRenderShopifySections(
      await addToCart(formData)
    )

    if (this.showMiniCartAfterSubmission) {
      utils.toggle(document.documentElement, ['mini-cart-is-active'])
    }

    this.submitButton.removeAttribute('disabled')
    this.submitButton.classList.remove('loading')
  }

  setSpacerHeight() {
    const wrapperEl = this.closest('.product-block__atc')
    const { height: wrapperHeight } = wrapperEl?.getBoundingClientRect() || { height: 0 }

    document.documentElement.style.setProperty(
      '--hh-atc-wrapper-height',
      `${wrapperHeight}px`
    )
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-form', HHProductForm)
